module.exports = __webpack_public_path__ + "img/pvp.e6977d8a.svg";